import service from "./service";
import { env } from "../env";

export const getClientServiceUrl: string = service("client");
export const getUserServiceUrl: string = service("user");
export const getSubscriptionServiceUrl: string = service("subscription");
export const getAuthServiceUrl: string = service("auth");
export const getAppointmentsServiceUrl: string = service("appointments");
export const getBillingServiceUrl: string = service("billing");
export const getTaskServiceUrl: string = service("task");
export const getCommunicationsServiceUrl: string = service("communications");

export const getHttpProtocol =
  env.REACT_APP_API_PROTOCOL || window.location.protocol;
export const subdomain = window.location.hostname.split(".")[0];
export const domain = window.location.hostname.split(".")[1];
export const fullAPIURL = `${getHttpProtocol}//${
  env.REACT_APP_API_HOSTNAME || env.API_BASE_URL
}`;

// API Gateway endpoints
export const calendarSyncBaseUrl = (() => {
  const nodeEnv = env.NODE_ENV
    ? env.NODE_ENV.toLowerCase()
    : process.env.NODE_ENV.toLowerCase();

  if (["dev", "development", "local"].includes(nodeEnv)) {
    return "https://c62grfq6ic.execute-api.us-east-1.amazonaws.com/development";
  } else if (["stage", "staging"].includes(nodeEnv)) {
    return "https://q8h0502cy3.execute-api.us-east-1.amazonaws.com/stage";
  } else if (["prod", "production"].includes(nodeEnv)) {
    return "https://3iz3g0hccd.execute-api.us-east-1.amazonaws.com/production";
  } else {
    throw new Error(`Unknown environment "${nodeEnv}"`);
  }
})();
